import type { ReactNode } from 'react';

export const DefaultGuard = ({ children }: { children: ReactNode }) => <>{children}</>;
